module.exports = __webpack_public_path__ + "static/media/Channels.cf018acc.svg";